import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buttonVariants } from "@/components/ui/button";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-6 px-6 py-16 text-center">
      <div className="space-y-2">
        <p className="text-5xl font-semibold tracking-tight">{t("public.notFound.code")}</p>
        <p className="text-muted-foreground">
          {t("public.notFound.message")}
        </p>
      </div>
      <Link to="/" className={buttonVariants({ variant: "outline" })}>
        {t("public.notFound.backHome")}
      </Link>
    </main>
  );
}
